const pointsNumberVariant = (element) => {
  if (element > 75) {
    return 'success';
  }
  if (element > 55 && element < 76) {
    return 'warning';
  }
  if (element < 56) {
    return 'alarm';
  }
  return 'info';
};
export default pointsNumberVariant;
